module.exports = __webpack_public_path__ + "img/logo.bbc5b233.png";